import { Link, useLocation, useParams } from 'react-router-dom';

import PropTypes from 'prop-types';

import { CURRENT_BC_PATH } from '../constants';
import CustomIcon from '../CustomIcons';
import { getAppConfig, updateSessionStorage } from '../utilities';

import './styles/index.css';

const BreadCrumb = ({
  buildByParam,
  matchLabelRoutes,
  isCustomTranslations,
  splitPathByRegex,
  customClass,
  showNumbers
}) => {
  const { pathname } = useLocation();
  const params = useParams();

  const { lang } = getAppConfig('locale');
  const BCLabels = getAppConfig('breadcrumbNames');
  const { path: serverPath, host } = getAppConfig('server');
  const breadcrumbNames = BCLabels[lang];

  const matchLabelBCRoutes = isCustomTranslations ? BCLabels.customTranslations[lang] : matchLabelRoutes;

  const breadcrumbLabels = { ...breadcrumbNames, ...matchLabelBCRoutes };

  let pathnames = [];

  if (buildByParam) {
    const currentPathBC = updateSessionStorage.getItem(CURRENT_BC_PATH);
    const pathToBeAdded = params && params[buildByParam];
    pathnames = [...currentPathBC.split('/').filter(path => path), pathToBeAdded];
  } else if (splitPathByRegex) {
    const pathSplitted = pathname.split(splitPathByRegex)[0];
    pathnames = pathSplitted.split('/').filter(path => path);
  } else {
    pathnames = pathname.split('/').filter(path => path);
  }

  let breadcrumbPath = '';

  const isLastPath = index => index === pathnames.length - 1;
  const dashboardCommonBC = (breadcrumbLabels && breadcrumbLabels.dashboard) || 'Dashboard';

  const DashboardBC = () => (
    <span data-testid="breadcrumb-link">
      <a href={`${host}${serverPath}/dashboard`}>
        <CustomIcon type="arrowLeft" size={15} />
        <span>{dashboardCommonBC}</span>
      </a>
    </span>
  );

  // eslint-disable-next-line no-restricted-globals
  const isPathANumber = str => (!isNaN(Number(str)) && showNumbers ? str : '');

  return (
    !!pathnames.length && (
      <div className={`breadcrumb ${customClass}`}>
        <DashboardBC />
        {pathnames.map((name, index) => {
          breadcrumbPath = `${breadcrumbPath}/${name}`;
          const breadcrumbName = breadcrumbLabels[name] || isPathANumber(name);
          return (
            breadcrumbName && (
              <span key={`${name}-${index}`} data-testid="breadcrumb-link">
                {' / '}
                {isLastPath(index) ? breadcrumbName : <Link to={breadcrumbPath}>{breadcrumbName}</Link>}
              </span>
            )
          );
        })}
      </div>
    )
  );
};

BreadCrumb.defaultProps = {
  buildByParam: '',
  matchLabelRoutes: {},
  splitPathByRegex: null,
  customClass: '',
  showNumbers: false,
  isCustomTranslations: false
};

BreadCrumb.propTypes = {
  buildByParam: PropTypes.string,
  matchLabelRoutes: PropTypes.instanceOf(Object),
  splitPathByRegex: PropTypes.instanceOf(RegExp),
  customClass: PropTypes.string,
  showNumbers: PropTypes.bool,
  isCustomTranslations: PropTypes.bool
};

export default BreadCrumb;
